

















































import CommonBase from "../CommonBase";
import {Component} from "vue-property-decorator";

@Component
export default class Videos extends CommonBase {
}
